import cx from 'classnames'
import styles from './CommonPage.css'
import Header from '../../Common/Header'
import Footer from './Footer'
import { SilentPageProvider } from '../../../context/silentPageContext'

const CommonPage = props => {
  const {
    className,
    supplier,
    page,
    actions,
    children,
    isHideNavigation = true
  } = props
  return (
    <SilentPageProvider>
      <div className={cx(styles.CommonPage, className)}>
        <Header
          key='header'
          supplier={supplier}
          page={page}
          actions={actions}
          isHideNavigation={isHideNavigation}
        />
        <main key='children'>
          {children}
        </main>
        <Footer key='footer' />
      </div>
    </SilentPageProvider>
  )
}

export default CommonPage
